import SurveysService from '../../services/surveys-service'
import Vue from 'vue'

Vue.component('surveys-archives', {
    data() {
        return {
            results: {}
        }
    },
    mounted() {
        this.getArchives()
    },
    methods: {
        async getArchives() {
            this.results = await SurveysService.archives.get()
        },
        async downloadArchive(archiveId) {
            const data = await SurveysService.archives.download(archiveId)

            if (data.error) {
                swal({
                    title: 'Export not ready',
                    text: data.error,
                    type: 'warning',
                    showCloseButton: true,
                    timer: 10000
                });
            }
        }
    }
})
